import { SiteUrls } from '@tableau/shared-urls';
import * as _ from 'underscore';
import { ServiceLocator } from '../../app/ServiceLocator';
import { Messages } from '../../codegen/Localize';
import { ServerSettingsUnauthenticated } from '../../settings/services/ServerSettingsUnauthenticated';
import { IAuthenticationProviderSelectorModel } from '../../ts/directives/tbAuthenticationProviderSelector';
import { ServerService } from '../../ts/services/ServerService';
import {
  AuthenticationProviderType,
  IAuthenticationProvider,
  SiteAuthenticationSettingsService,
} from '../../ts/services/SiteAuthenticationSettingsService';

function getInitialAuthenticationProviderSelectorModel(): IAuthenticationProviderSelectorModel {
  const serverService = ServiceLocator.get<ServerService>('ServerService');
  const siteAuthenticationSettingsService = ServiceLocator.get<SiteAuthenticationSettingsService>('SiteAuthenticationSettingsService');
  return {
    getProviderDisplayName: (provider: IAuthenticationProvider) => {
      const translateValues = {
        PROVIDER_NAME: siteAuthenticationSettingsService.getProviderDisplayName(provider),
      };
      return Messages.addUsersWithAuthentication(translateValues);
    },
    getProviderDescription: (provider: IAuthenticationProvider, inviteNotificationEnabledForSite: boolean) => {
      const getTranslation = (): string => {
        if (provider.type === AuthenticationProviderType.default) {
          if (ServerSettingsUnauthenticated.isTableauIdSupported()) {
            return Messages.addUsersWithAuthentication_description_tableauid();
          }
        } else {
          // conditional descriptions for 1) both when the server config for site invite notifications is turned on and off and for 2) Site level settings on/off
          return serverService.isSiteInviteEmailEnabledForServer()
            ? (inviteNotificationEnabledForSite ?
              Messages.addUsersWithAuthentication_description_external_email() :
              Messages.addUsersWithAuthentication_description_external_email_off({SITE_INVITE_NOTIF_SETTINGS_URL: getSiteInviteUrl()}))
            : Messages.addUsersWithAuthentication_description_external(
              {SERVER_NAME: ServerSettingsUnauthenticated.serverName(),
              PROVIDER_NAME: siteAuthenticationSettingsService.getProviderDisplayName(provider)});
        }
      };

      const getSiteInviteUrl = (): string => {
        const siteUrls = new SiteUrls({
          siteUrlName: serverService.sessionSiteUrlName(),
          queryString: window.location.search
        });
        return `<a href=${siteUrls.settingsUrl()}>${Messages.goToSiteInviteNotifSettings()}</a>`;
      };

      return getTranslation();
    },
    authenticationProvider: siteAuthenticationSettingsService.getDefaultProvider(),
    authSetting: 'DEFAULT', // should be removed by TFSID:607630
    authenticationProviderIds: undefined
  };
}

export const AuthenticationProviderHelper = {
  getInitialAuthenticationProviderSelectorModel
};
